/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const PricingVersion = z.object({ ags: z.string(), extend: z.string() })

export interface PricingVersion extends z.TypeOf<typeof PricingVersion> {}
